import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  ONCHANGE_DATE,
  ONCHANGE_FILTER_SELECTED_PHONGBAN,
  ONCHANGE_FROM_HOME_TO_PROCESSING,
} from "../../redux/reducers/workingReducer/_index";

import Select from "react-select";
import { onTouchForm } from "../../funcs/onTochForm";
import DateTimePickerControl from "../../controls/datetimePicker/datetimePickerControl";
import OrganizationUtils from "../../utils/organizations/organizationUtils";
import LevelComponent from "../organizations/levels/levelComponent";
import OrganizationRepository from "../../repositories/organizations/organizationRepository";

const WorkingReceiverTaskMyself = () => {
  const workingData = useSelector((state: any) => state.workingReducer);
  const dispatch = useDispatch();
  const [organizations, setOrganization] = useState<any>([]);
  const urlLink = window.location.pathname;

  const getListOrganization = () => {
    OrganizationRepository.getListByCurrentUser().then((res: any) => {
      if (res.status) {
        const data = res.data || [];

        const organizationTrees = OrganizationUtils.getListTree(data, {
          id: "PhongBanId",
          parentId: "RefID",
        });

        const organizationTreeValueLabels =
          OrganizationUtils.convertToListValueLabel(organizationTrees, {
            value: "PhongBanId",
            label: "PhongBan",
          });

        setOrganization(organizationTreeValueLabels);
      }
    });
  };

  useEffect(() => {
    getListOrganization();
  }, []);

  const tempReceiverList = workingData.receiverList?.map((item: any) => {
    return { ...item, label: item.FullName, value: item.FullName };
  });
  const tempBossList = workingData.bossList?.map((item: any) => {
    return { ...item, label: item.FullName, value: item.FullName };
  });
  const tempPhongBan = workingData.listPhongBan?.map((item: any) => {
    return { ...item, label: item.ParameterValue, value: item.ParameterValue };
  });

  let tempSelectedPhongBan = tempPhongBan?.find(
    (item: any) => item.ParameterId === workingData.searchFilter.selectPhongBan
  );

  // const [fromDate, setFromDate] = useState<any>();
  // const [toDate, setToDate] = useState<any>();
  // useEffect(()=>{
  //   console.log("workingData.searchFilter.fromDate = ",workingData.searchFilter.fromDate );
  //   console.log("workingData.searchFilter.toDate = ",workingData.searchFilter.toDate );
  //   setFromDate(workingData.searchFilter.fromDate);
  //   setToDate(workingData.searchFilter.toDate);
  //   console.log("fromDate = ",fromDate );
  //   console.log("toDate = ",toDate );
  // },[workingData.searchFilter.fromDate, workingData.searchFilter.toDate])

  return (
    <div className="flex lg:flex-row flex-col w-full h-max gap-2 lg:gap-5">
      <DateTimePickerControl
        label={"Ngày giao (Từ ngày)"}
        value={workingData.searchFilter.fromDate}
        onChange={(e: any) => {
          const value = e;
          dispatch(ONCHANGE_DATE({ type: "fromDate", value }));
        }}
      />

      <DateTimePickerControl
        label={"Ngày giao (Đến ngày)"}
        value={workingData.searchFilter.toDate}
        onChange={(e: any) => {
          const value = e;
          dispatch(ONCHANGE_DATE({ type: "toDate", value }));
        }}
      />

      <DateTimePickerControl
        label={"Thời hạn"}
        // value={workingData.searchFilter.deadLine}
        onChange={(e: any) => {
          const value = e;
          dispatch(ONCHANGE_DATE({ type: "deadLine", value }));
        }}
      />
    </div>
  );
};

export default WorkingReceiverTaskMyself;
